// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-placename {
    text-anchor: start;
}

.em-placename-halo {
    text-anchor: start;
    fill:none;
    stroke: white;
    opacity:0.8;
    stroke-linejoin: round;
}`, "",{"version":3,"sources":["webpack://./src/css/placenames.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":[".em-placename {\r\n    text-anchor: start;\r\n}\r\n\r\n.em-placename-halo {\r\n    text-anchor: start;\r\n    fill:none;\r\n    stroke: white;\r\n    opacity:0.8;\r\n    stroke-linejoin: round;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
